/* Live preview for the tp_engraving product block. Submission needs no script:
   the text input and font radios are plain form fields on the product form. */
if (!customElements.get("tp-engraving")) {
  customElements.define("tp-engraving", class extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector("[data-engrave-input]");
      this.count = this.querySelector("[data-engrave-count]");
      this.preview = this.querySelector("[data-engrave-preview]");
      if (!this.input || !this.count || !this.preview) {
        return;
      }
      this.onChange = () => this.update();
      this.addEventListener("input", this.onChange);
      this.addEventListener("change", this.onChange);
      this.update();
    }

    disconnectedCallback() {
      if (this.onChange) {
        this.removeEventListener("input", this.onChange);
        this.removeEventListener("change", this.onChange);
      }
    }

    update() {
      const text = this.input.value;
      this.count.textContent = String(text.length);
      this.preview.textContent = text.trim() ? text : this.preview.dataset.empty;
      const font = this.querySelector('input[type="radio"]:checked');
      if (font) {
        this.preview.style.fontFamily = font.dataset.family;
      }
    }
  });
}
